export * from './header/header.component';
export * from './header/components/agenda-compromissos/agenda-compromissos.component';
export * from './footer/footer.component';
export * from './search-input/search-input.component';
export * from './tiny-mce/tiny-mce.component';
export * from './assistente-virtual/assistente-virtual.component';
export * from './basic';
